/**
 * State used in rendering Tab
 */ "use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
